import React, {FunctionComponent, useCallback, useEffect, useRef, useState} from "react";

import {
    ACard,
    ADataGrid, ADataGridColumn,
    ADataGridFilter, FloatMenuButton, FloatMenuItem,
    APopoverIcon, PagedSearchParams,
} from "@atiautomacao/ati-ui-library";

import { extractFiltersFromColumns } from "../../../../../../Utils/DataUitils";
import { RootState } from "../../../../../../Config/Store";
import { useAppDispatch, useAppSelector } from "../../../../../../Config/Hooks";
import {searchEntities, reset, clear} from "./GroupingByPowerPlantReducer";
import {AlarmRow} from "../../AlarmPage"
import {Alarm} from "../../AlarmPowerPlantReducer"
import {alarmFinalize,alarmAcknowledge, AlarmActionArgs} from "../../../../Alarms/AlarmReducer"
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faDownload, faExpand, faFileCsv, faGear, faPrint} from "@fortawesome/free-solid-svg-icons";
import IconButton from "@mui/material/IconButton";
import {BorderColor, MoreVert} from "@mui/icons-material";
import VolumeUpIcon from '@mui/icons-material/VolumeUp';
import {isArray} from "lodash";
import {DateFormat} from "../../../../../../Utils/DateFormatPatternUtils";
import {
    Box,
    Button, Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle,
    Modal,
    useTheme
} from "@mui/material";
import {checkGroupingType, getAlarmDisplayLabel, handleOnColor} from "../../../../../../Utils/AlarmsService";
import AlarmNotion from "../../../../Alarms/Components/AlarmNotion";
import {useSnackbar} from "notistack";
import Tooltip from "@mui/material/Tooltip";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import CancelIcon from "@mui/icons-material/Cancel";
import { hasPermission } from "../../../../../../Shared/Auth/AuthenticationUtil";
import { AUTHORITIES } from "../../../../../../Config/Constants";
import {
    applyFiltersToAlarmColumns,
    buildAlarmDateFilterSanitizationMessage,
    buildAlarmDateFilterValidationMessage,
    processAlarmDateFilters,
} from "../../../../../../Utils/AlarmDateFilterValidationUtils";

const initColumns = [
    {
        name: 'id',
        label: 'ID',
        align: 'left',
        minWidth: 10,
        visibility: false,
        breakpoints: {
            xs: true,
            sm: true,
            md: true,
            lg: true,
            xl: true
        }
    },
    {
        name: 'severityName',
        label: 'severidade',
        align: 'left',
        visibility: true,
        minWidth: 10,
        breakpoints: {
            xs: true,
            sm: true,
            md: true,
            lg: true,
            xl: true
        },
    },
    {
        name: 'description',
        label: 'descrição',
        align: 'left',
        visibility: true,
        minWidth: 50,
        breakpoints: {
            xs: true,
            sm: true,
            md: true,
            lg: true,
            xl: true
        }
    },
    {
        name: 'macroRegionName',
        label: 'macro',
        align: 'left',
        visibility: false,
        minWidth: 10,
        breakpoints: {
            xs: true,
            sm: true,
            md: true,
            lg: true,
            xl: true
        }
    },
    {
        name: 'regionName',
        label: 'região',
        align: 'left',
        visibility: false,
        minWidth: 10,
        breakpoints: {
            xs: true,
            sm: true,
            md: true,
            lg: true,
            xl: true
        }
    },
    {
        name: 'skidName',
        label: 'skid',
        align: 'left',
        visibility: true,
        minWidth: 10,
        breakpoints: {
            xs: true,
            sm: true,
            md: true,
            lg: true,
            xl: true
        }
    },
    {
        name: 'equipmentName',
        label: 'equipamento',
        align: 'left',
        visibility: true,
        minWidth: 10,
        breakpoints: {
            xs: true,
            sm: true,
            md: true,
            lg: true,
            xl: true
        }
    },
    {
        name: 'dateTime',
        label: 'início',
        align: 'left',
        minWidth: 10,
        visibility: true,
        breakpoints: {
            xs: true,
            sm: true,
            md: true,
            lg: true,
            xl: true
        },
        filter: {
            name: "dateTime",
            condition: "starts-at",
            value: "",
            sort: "none",
            placeholder: 'dd/MM/yyyy HH:mm:ss'
        }
    },
    {
        name: 'clearDate',
        label: 'finalizado',
        align: 'left',
        minWidth: 10,
        visibility: true,
        breakpoints: {
            xs: true,
            sm: true,
            md: true,
            lg: true,
            xl: true
        },
        filter: {
            name: "clearDate",
            condition: "starts-at",
            value: "",
            sort: "none",
            placeholder: 'dd/MM/yyyy HH:mm:ss'
        }
    },
    {
        name: 'acknowledgementDate',
        label: 'reconhecido',
        align: 'left',
        minWidth: 10,
        visibility: true,
        breakpoints: {
            xs: true,
            sm: true,
            md: true,
            lg: true,
            xl: true
        },
        filter: {
            name: "acknowledgementDate",
            condition: "starts-at",
            value: "",
            sort: "none",
            placeholder: 'dd/MM/yyyy HH:mm:ss'
        }
    },
    {
        name: 'userName',
        label: 'usuário',
        align: 'left',
        minWidth: 10,
        visibility: true,
        breakpoints: {
            xs: true,
            sm: true,
            md: true,
            lg: true,
            xl: true
        }
    },
] as ADataGridColumn[]


const style = {
    position: 'absolute' as 'absolute',
    top: '55%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: '70%',
    bgcolor: 'background.paper',
    border: '1px solid #666',
    // borderRadius: '25px'
}
const AlarmGroup: FunctionComponent<{alarm:any | null}> = ({alarm} ) => {

    const dispatch = useAppDispatch();
    const theme = useTheme();
    const { enqueueSnackbar } = useSnackbar();

    const isLoading = useAppSelector((state : RootState) => state.groupingByPowerPlant.loading);
    const totalOfRecords = useAppSelector((state : RootState) => state.groupingByPowerPlant.totalOfRecords);
    const entities: Array<Alarm> = useAppSelector((state: RootState) => state.groupingByPowerPlant.entities);
    const account = useAppSelector(state => state.authentication.account);
    const isAuthorizedToAcknowledge = hasPermission(account?.authoritySet, [
        AUTHORITIES.SYSADMIN, AUTHORITIES.DASHBOARD_POWER_STATION_ALARM_ACKNOWLEDGE
    ]);

    const isAuthorizedToFinalize = hasPermission(account?.authoritySet, [
        AUTHORITIES.SYSADMIN, AUTHORITIES.DASHBOARD_POWER_STATION_ALARM_FINALIZE
    ]);

    const [rows, setRows] = useState<Array<AlarmRow>>([]);
    const [columns, setColumns] = useState<Array<ADataGridColumn>>(
        applyFiltersToAlarmColumns(initColumns, extractFiltersFromColumns(initColumns))
    );
    const [pagedSearchParams, setPagedSearchParams] = useState(new PagedSearchParams(extractFiltersFromColumns(initColumns), 0, 100));
    const [open, setOpen] = React.useState(false);
    const [entityToModel, setEntityToModel] = useState<object>();
    const [selectedRows, setSelectedRows] = useState<any>();
    const [hasAlarmSound, setHasAlarmSound] = useState(false);
    const [dialogOpen, setDialogOpen] = useState(false);
    const [acknowledgeDialog, setAcknowledgeDialog] = useState(false);

    const showAlarmDateFilterSanitizationMessage = (fieldLabels: Array<string>) => {
        enqueueSnackbar(buildAlarmDateFilterSanitizationMessage(fieldLabels), {variant: 'warning'});
    };

    const showAlarmDateFilterValidationMessage = (fieldLabels: Array<string>) => {
        enqueueSnackbar(buildAlarmDateFilterValidationMessage(fieldLabels), {variant: 'error'});
    };

    const validatePagedSearchParams = (params: PagedSearchParams, showMessage = true): PagedSearchParams | null => {
        const processedResult = processAlarmDateFilters(params.filters);

        if (processedResult.wasSanitized) {
            if (showMessage) {
                showAlarmDateFilterSanitizationMessage(processedResult.sanitizedFieldLabels);
            }
            return null;
        }

        if (!processedResult.isValid) {
            if (showMessage) {
                showAlarmDateFilterValidationMessage(processedResult.invalidFieldLabels);
            }
            return null;
        }

        return new PagedSearchParams(processedResult.convertedFilters, params.page, params.size);
    };

    const buildGroupedSearchParams = (params: PagedSearchParams): PagedSearchParams => (
        new PagedSearchParams(
            [
                ...params.filters,
                {name: 'powerStationId', condition: 'equals', value: alarm.powerStationId?.toString() || '', sort: 'none'},
                ...checkGroupingType(alarm),
            ],
            params.page,
            params.size
        )
    );

    const handleOnFiltersChange = useCallback((dataGridFilters: Array<ADataGridFilter>, page: number, pageSize: number) => {
        const processedResult = processAlarmDateFilters(dataGridFilters);

        // Sync columns only when sanitization changed values — avoids ADataGrid onFiltersChange loop
        if (processedResult.wasSanitized) {
            setColumns(applyFiltersToAlarmColumns(initColumns, processedResult.filters));
            showAlarmDateFilterSanitizationMessage(processedResult.sanitizedFieldLabels);
            return;
        }

        if (!processedResult.isValid) {
            showAlarmDateFilterValidationMessage(processedResult.invalidFieldLabels);
            return;
        }

        setPagedSearchParams(
            new PagedSearchParams(processedResult.filters, page, pageSize)
        );
    }, []);

    const handleOnRowSelect = useCallback((row: any) => {
        // console.log(`handleOnRowSelect()`, row);
    }, []);

    useEffect(() => {

        dispatch(reset());
        if (!isLoading && alarm ) {
            const validatedParams = validatePagedSearchParams(pagedSearchParams);

            if (validatedParams) {
                dispatch(searchEntities({params: buildGroupedSearchParams(validatedParams)}));
            }
        }
    }, [alarm])

    const paramsRef = useRef(false);
    useEffect(() => {
        dispatch(reset());
        if (paramsRef.current) {
            if (alarm && pagedSearchParams?.filters) {
                const validatedParams = validatePagedSearchParams(pagedSearchParams);

                if (!validatedParams) {
                    return;
                }

                dispatch(searchEntities({params: buildGroupedSearchParams(validatedParams)}));
            }
        } else {
            paramsRef.current = true;
        }
    }, [pagedSearchParams]);

    const structureRow = (entitiesValues: Array<Alarm>) => {
        let newHasAlarmSound = false;
        let entity: Array<AlarmRow> = []
        entitiesValues.forEach( alarm => {
            entity.push({
                id: alarm.id.toString(),
                teleObjectId: alarm.teleObjectId,
                teleObjectInhibited: alarm.teleObjectInhibited,
                severityId: alarm.severityId,
                severityName: alarm.teleObjectInhibited
                    ? getAlarmDisplayLabel(alarm)
                    : (alarm?.clearDate == null || alarm?.clearDate.length < 1) && (alarm?.acknowledgementDate == null || alarm?.acknowledgementDate.length < 1) && alarm?.hasAlarmSound ?
                    <>
                        <VolumeUpIcon fontSize="small" sx={{ verticalAlign: 'middle', marginRight: 0.5, color: theme.palette.primary.main }}/>
                        {alarm.severityName}
                    </> : alarm.severityName,
                severityColor: alarm.severityColor,
                description: alarm.description,
                macroRegionName: alarm.macroRegionName,
                regionName: alarm.regionName,
                powerStationId: alarm.powerStationId,
                powerStationName: alarm.powerStationName,
                skidId: alarm.skidId,
                skidName: alarm.skidName,
                equipmentId: alarm.equipmentId,
                equipmentName: alarm.equipmentName,
                clearDate: alarm.clearDate ? DateFormat(alarm.clearDate) : "",
                acknowledgementDate: alarm.acknowledgementDate ? DateFormat(alarm.acknowledgementDate) : "",
                dateTime: DateFormat(alarm.dateTime),
                userName: alarm.userName,
                hasAlarmSound: alarm.hasAlarmSound,
                group: false,
                actionsConfig: [
                    {actionName: "note", disabled: false},
                    {actionName: "acknowledge", disabled: isAuthorizedToAcknowledge ? (alarm.acknowledgementDate != null) : true},
                    {actionName: "finalize", disabled: isAuthorizedToFinalize ? (alarm.clearDate != null) : true}
                ],
            });
            if((alarm?.clearDate == null || alarm?.clearDate.length < 1) && (alarm?.acknowledgementDate == null || alarm?.acknowledgementDate.length < 1) && alarm?.hasAlarmSound === true && !newHasAlarmSound){
                newHasAlarmSound = true;
            }
        });
        // Remove recent alarm from overview table
        //entity.shift();
        setHasAlarmSound(newHasAlarmSound);
        setRows(entity);
    }


    const alarmSound = async () => {
        const audio = new Audio(process.env.PUBLIC_URL + "/notification_02.mp3");
        audio.volume = 0.7;
        const audioMuted = localStorage.getItem("audioMuted") === "true";
        try {
            await new Promise((resolve) => {
                
                audio.onended = resolve;
                audio.oncanplay = () => {
                    audio.muted = !audioMuted;
                    if(audioMuted){
                        audio.play();
                    }
                };
            });
        } catch (err) {
            console.log("error", err);
        }
    }

    useEffect(() => {        
        if (hasAlarmSound) {
            const intervalo = setInterval(() => {                
                alarmSound();
            }, 2000);
      
            return () => clearInterval(intervalo);
        }
    },[hasAlarmSound]);

    const entitiesRef = useRef(false);
    useEffect(() => {
        if(!entitiesRef.current){
            entitiesRef.current = true;
        }
    },[entities]);

    const columnsRef = useRef(false);
    useEffect(() => {
        if(!columnsRef.current){
            columnsRef.current = true;
        }
    },[initColumns]);

    useEffect(() => {
        if (isArray(entities) && entities.length > 1) {
            structureRow(entities);
        }else{
            setRows([]);
             setHasAlarmSound(false);
        }
    }, [entities]);

    const handleOnNotionOpen = useCallback(async (data: any) => {
        if(data) {
            setEntityToModel(data);
            setOpen(true)
        }
    }, []);

    // close modal
    const handleCloseModal = () => {
        setOpen(false);
    }

    const finalizeAlarms = useCallback(async () => {
        handleClose()
        if(isArray(selectedRows)){
            const rowSelected = selectedRows.filter((row) => row.selected)
            const params:AlarmActionArgs = {
                alarmsListId: rowSelected.map((row) => Number(row.data.id))
            }
            const actionResult = await dispatch(alarmFinalize(params))
            if(alarmFinalize.fulfilled.match(actionResult)){
                dispatch(clear());
                dispatch(searchEntities({params:pagedSearchParams}));
            }
        }else if(selectedRows){
            const actionResult = await dispatch(alarmFinalize({alarmsListId: [Number(selectedRows.id)]}))
            if(alarmFinalize.fulfilled.match(actionResult)){
                dispatch(clear());
                dispatch(searchEntities({params:pagedSearchParams}));
            }
        }
    },[selectedRows]);


    const alarmAcknowledges = useCallback(async() => {
        handleClose()
        if(isArray(selectedRows)){
            const rowSelected = selectedRows.filter((row) => row.selected)
            const params:AlarmActionArgs = {
                alarmsListId: rowSelected.map((row) => Number(row.data.id))
            }
            const actionResult = await dispatch(alarmAcknowledge(params))
            if(alarmAcknowledge.fulfilled.match(actionResult)){
                dispatch(clear());
                dispatch(searchEntities({params:pagedSearchParams}));
            }
        }else if(selectedRows){
            const actionResult = await dispatch(alarmAcknowledge({alarmsListId: [Number(selectedRows.id)]}))
            if(alarmAcknowledge.fulfilled.match(actionResult)){
                dispatch(clear());
                dispatch(searchEntities({params:pagedSearchParams}));
            }
        }
    },[selectedRows]);

    const handleClickOpen = (rows:any) => {
        if(isAuthorizedToFinalize) {
            setSelectedRows(rows);
            setDialogOpen(true);
        } else {
            enqueueSnackbar("Você não está autorizado à acessar essa funcionalidade", {
                variant: 'warning',
            });
            return null;
        }
        
    };

    const handleAcknowledgeClick = (rows:any) => {
        if(isAuthorizedToAcknowledge) {
            setSelectedRows(rows);
            setAcknowledgeDialog(true)
        } else {
            enqueueSnackbar("Você não está autorizado à acessar essa funcionalidade", {
                variant: 'warning',
            });
            return null;
        }
        
    }

    const handleClose = () => {
        setDialogOpen(false);
        setAcknowledgeDialog(false);
    };

    return (
        <Box sx={style}>
            <ACard
                title="Agrupamento de alarme"
                // headerActions={
                //     <FloatMenuButton
                //         icon={<MoreVert/>}
                //         tooltip={"Floating Menu"}
                //     >
                //         <FloatMenuItem
                //             icon={<FontAwesomeIcon icon={faGear} fontSize={20}/>}
                //             text="Settings"
                //             disable={true}
                //             link={"/"}
                //         />
                //         <FloatMenuItem
                //             icon={<FontAwesomeIcon icon={faExpand} fontSize={20}/>}
                //             text="Expand"
                //             disable={true}
                //         />
                //         <FloatMenuItem
                //             icon={<FontAwesomeIcon icon={faPrint} fontSize={20}/>}
                //             text="Print"
                //             disable={true}
                //         />
                //     </FloatMenuButton>
                // }
                footerActions={
                    <APopoverIcon icon={<FontAwesomeIcon icon={faDownload} fontSize={20}/>}>
                        <IconButton disabled={true}>
                            <FontAwesomeIcon icon={faFileCsv} fontSize={20} />
                        </IconButton>
                    </APopoverIcon>
                }
            >
                <ADataGrid
                    hideFilters={true}
                    showFilterOptions={false}
                    hideSelection={false}
                    size={"small"}
                    columns={columns}
                    rows={rows}
                    page={pagedSearchParams.page}
                    loading={false}
                    totalOfRecords={totalOfRecords? totalOfRecords-1 : 0}
                    rowsPerPage={pagedSearchParams.size}
                    onFiltersChange={handleOnFiltersChange}
                    onRowSelect={handleOnRowSelect}
                    onColorSelect={handleOnColor}
                    actionColumnWidth={160}
                    actions={
                        <>
                            <IconButton name="note" aria-label="Border color" onClick={handleOnNotionOpen}>
                                <BorderColor sx={{ fontSize: 26 }} />
                            </IconButton>
                            <IconButton name="acknowledge" size={"small"} aria-label="Fact check" onClick={handleAcknowledgeClick} disabled={!isAuthorizedToAcknowledge}>
                                <Tooltip title="Reconhecer alarme">
                                    <CheckCircleIcon />
                                </Tooltip>
                            </IconButton>
                            <IconButton name="finalize" size={"small"} aria-label="Border color" onClick={handleClickOpen} disabled={!isAuthorizedToFinalize}>
                                <Tooltip title="Finalizar alarme">
                                    <CancelIcon />
                                </Tooltip>
                            </IconButton>
                        </>
                    }
                />
                <Modal
                    open={open}
                    onClose={handleCloseModal}
                    aria-labelledby="modal-modal-title"
                    aria-describedby="modal-modal-description"
                >
                    <AlarmNotion alarm={entityToModel} />

                </Modal>
                <Dialog open={dialogOpen || acknowledgeDialog} onClose={handleClose}>
                    <DialogTitle>{`Confirmar ${dialogOpen ? 'finalização' : 'reconhecimento'}`}</DialogTitle>
                    <DialogContent>
                        <DialogContentText>
                            Tem certeza de que deseja {dialogOpen ? 'finalizar' : 'reconhecer'} este alarme?
                        </DialogContentText>
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={handleClose}>Cancelar</Button>
                        <Button onClick={dialogOpen ? finalizeAlarms : alarmAcknowledges} autoFocus>
                            Confirmar
                        </Button>
                    </DialogActions>
                </Dialog>
            </ACard>
        </Box>
    )

}

export default AlarmGroup;
